import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import type { GuideWithSteps } from "@shared/modules/guides";
import { blueprint } from "../../../core/blueprint";
import { BrandMark } from "../../../core/components/ui/brand-mark";
import { guidesApi } from "../lib/api";
import { GuideReader } from "../components/guide-reader";

/**
 * Lecteur public hors shell : /g/:slug. Sans connexion, seuls les guides
 * publics publiés répondent ; un compte connecté (cookie) voit aussi ceux
 * réservés aux membres.
 */
export function GuidePublicPage() {
  const { slug = "" } = useParams();
  const [guide, setGuide] = useState<GuideWithSteps | null | undefined>(undefined);

  useEffect(() => {
    setGuide(undefined);
    guidesApi
      .bySlug(slug)
      .then(setGuide)
      .catch(() => setGuide(null));
  }, [slug]);

  useEffect(() => {
    const base = blueprint.name;
    document.title = guide ? `${guide.title} — ${base}` : base;
    return () => {
      document.title = blueprint.tagline ? `${base} — ${blueprint.tagline}` : base;
    };
  }, [guide]);

  return (
    <div className="guide-public">
      <header className="guide-public__header">
        <Link to="/" className="guide-public__brand">
          <BrandMark size={30} />
          <span className="guide-public__brand-name">{blueprint.name}</span>
        </Link>
        <Link to="/" className="guide-public__login">
          Se connecter
        </Link>
      </header>

      <main className="guide-public__main">
        {guide === undefined ? <p className="muted">Chargement…</p> : null}
        {guide === null ? (
          <div className="guide-public__missing">
            <h1 className="guide-public__title">Guide introuvable</h1>
            <p className="muted">
              Ce guide n'existe pas, n'est pas publié ou est réservé aux comptes connectés.{" "}
              <Link to="/">Se connecter</Link>
            </p>
          </div>
        ) : null}
        {guide ? (
          <>
            <div className="guide-public__head">
              <h1 className="guide-public__title">{guide.title}</h1>
              {guide.description ? <p className="guide-public__desc">{guide.description}</p> : null}
            </div>
            <GuideReader guide={guide} />
          </>
        ) : null}
      </main>

      <footer className="guide-public__foot">
        {blueprint.name}
        {blueprint.tagline ? ` · ${blueprint.tagline}` : ""}
      </footer>
    </div>
  );
}
